// THE THREE PHASES OF A HARD SKIP, in order.
//
// These are not decoration -- the stepper times the section swap against
// them, so they are a contract rather than a look. Exported as numbers and
// applied below as inline transition durations rather than as Tailwind
// `duration-*` classes, so the timing the stepper waits on and the timing
// the pixels actually use cannot drift apart.

// 1. The cover fades UP over the outgoing section, which is still playing.
//    Nothing is torn down yet; the user just sees the shot go dark.
export const SECTION_SKIP_COVER_FADE_IN_MS = 200;

// 2. Fully opaque. THE SWAP HAPPENS HERE -- the outgoing section's
//    animation is stopped, the incoming one is mounted, and every ref the
//    old visit left behind snaps to the new section's entry state. All of
//    that is instantaneous and none of it is visible.
export const SECTION_SKIP_COVER_HOLD_MS = 300;

// 3. The cover fades back DOWN, and the incoming section's animation is
//    already running underneath it -- so the section emerges FROM the dark
//    rather than being uncovered after the fact. Matches how the section
//    timelines' own 'stage' layer hands over; see COVER_FADE_SECONDS.
export const SECTION_SKIP_COVER_FADE_OUT_MS = 500;

// How long the cover is held up in total, and therefore how long after
// raising it the stepper may lower it again.
export const SECTION_SKIP_COVER_TOTAL_MS =
  SECTION_SKIP_COVER_FADE_IN_MS + SECTION_SKIP_COVER_HOLD_MS;
